import { DashboardApi } from 'api/api'
import { createApiInstance } from 'utils'

const apiInstance = () => createApiInstance(DashboardApi)

export const fetchDashboard = (timeFilter?: { year?: number; month?: number }) => {
  return apiInstance().get(timeFilter?.year, timeFilter?.month)
}
